'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MeetingInfoCollection = {
  meetingInfos: {},

  /**
   *
   * @param {String} id ID of the meeting info you wish to retreive
   * @returns {MeetingInfo} returns a meeting info instance
   */
  get: function get(id) {
    if (this.meetingInfos[id]) {
      return this.meetingInfos[id];
    }

    return (0, _find3.default)(this.meetingInfos, function (info) {
      return info.sipUrl === id || info.locusId === id || info.userId === id || info.meetingLink === id;
    });
  },


  /**
   *
   * @param {String} id the id of the meeting info instance to add to the collection
   * @param {Object} info the full meeting info object
   * @returns {MeetingInfo} returns the meeting info instance that was added to the collection
   */
  set: function set(id, info) {
    this.meetingInfos[id] = info;
    return this.meetingInfos[id];
  },


  /**
   * @returns {Object} returns an object map of MeetingInfo instances
   */
  getAll: function getAll() {
    return this.meetingInfos;
  }
};

exports.default = MeetingInfoCollection;
//# sourceMappingURL=collection.js.map
